
import { Vue, Component, Inject } from 'vue-property-decorator';
import { PackageItem } from '@/features/shipment/types';
import { getPackageDetails } from '@/features/common/helpers';

@Component
export default class PackagesDetail extends Vue {
  @Inject({ default: false }) readonly isEstimatePage!: boolean;

  get packages(): PackageItem[] {
    if (this.isEstimatePage) {
      return this.$store.state.estimate.estimateData.packages;
    }
    return this.$store.getters.getPackageSummary;
  }

  private getPackageDetails = getPackageDetails;
}
